// extracted by mini-css-extract-plugin
module.exports = {"support-container":"Support_support-container__2P3D8","support-text":"Support_support-text__1PjJd"};